export type WasmGameInstance = {
  addLocalPlayer(profileJson: string): number;
  hasLocalPlayer(): boolean;
  localPlayerId(): number | undefined;
  setInput(x: number, y: number, sequence: number): void;
  tick(deltaMs: number): void;
  tickFixed(): void;
  snapshotJson(): string;
  chooseUpgradeJson(upgradeJson: string): void;
  respawnLocalPlayer(): void;
  realPlayerCount(): number;
  shouldCloseRoom(): boolean;
  tickNumber(): bigint | number;
  configJson(): string;
  debugStateJson(): string;
};

type WasmModule = {
  default: () => Promise<unknown>;
  WasmGame: new (seed: bigint | number) => WasmGameInstance;
  defaultConfigJson: () => string;
  validateProfileJson: (profileJson: string) => string;
};

let modulePromise: Promise<WasmModule> | null = null;

export async function loadWasmModule(): Promise<WasmModule> {
  if (!modulePromise) {
    modulePromise = import("./pkg/game_wasm.js") as unknown as Promise<WasmModule>;
  }

  const module = await modulePromise;
  await module.default();
  return module;
}

export async function loadWasmGame(seed: number): Promise<WasmGameInstance> {
  const module = await loadWasmModule();
  return new module.WasmGame(BigInt(seed));
}

export async function getDefaultConfig(): Promise<unknown> {
  const module = await loadWasmModule();
  return JSON.parse(module.defaultConfigJson());
}

export async function validateProfile(profile: unknown): Promise<unknown> {
  const module = await loadWasmModule();
  return JSON.parse(module.validateProfileJson(JSON.stringify(profile)));
}